import { createSlice, PayloadAction } from "@reduxjs/toolkit"

import { ApiTypes } from "types"
import { StorageKeys } from "types/enums/StorageKeys"
import TemperatureScale from "types/enums/TemperatureScale"

import { getStorageItem } from "utils/localStorage"
import { setSentryUserContext } from "utils/sentryUserContext"

export interface ModalsState {
  isUserAuthorized: boolean
  userProfile: ApiTypes.Model.UserProfile | null
  userTemperatureScale: TemperatureScale | null
}

const token = getStorageItem(StorageKeys.Token)
const userProfile = getStorageItem(StorageKeys.UserProfile)
const userTemperatureScale = getStorageItem(StorageKeys.UserTemperatureScale)

const initialState: ModalsState = {
  isUserAuthorized: token ? true : false,
  userProfile: userProfile || null,
  userTemperatureScale: userTemperatureScale,
}

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserAuthorized: (state, action: PayloadAction<boolean>) => {
      state.isUserAuthorized = action.payload
    },
    setUserProfile: (state, action: PayloadAction<ApiTypes.Model.UserProfile | null>) => {
      state.userProfile = action.payload
      setSentryUserContext(action.payload)
    },
    setUserTemperatureScale: (state, action: PayloadAction<TemperatureScale>) => {
      state.userTemperatureScale = action.payload
    },
  },
})

export const { setUserAuthorized, setUserProfile, setUserTemperatureScale } = userSlice.actions

export default userSlice.reducer
